import QuickApprovalWorkflow from './QuickApprovalWorkflow';
import DirectLink from './DirectLink';

const Modals = {
  QUICK_APPROVAL_WORKFLOW: QuickApprovalWorkflow,
  DIRECT_LINK: DirectLink,
}

export default Modals;
